export default ({ next, store }) => {
  if (!store.getters.isEkaterina) {
    return next({ name: 'time-log-weekly' })
  }

  return next()
}
